export default "__VITE_ASSET__Bxr8We8U__"